import React from 'react';
import { InstagramIcon, TiktokIcon, YoutubeIcon, FacebookIcon } from '@revfluence/fresh-icons/brands/esm';
import { ContentPreviewHeaderProps, PostType } from '../types';

export const PlatformIcon = ({
  platform,
  className = 'h-5 w-5',
}: {
  platform: ContentPreviewHeaderProps['platform'];
  className?: string;
}) => {
  switch (platform) {
    case 'instagram':
      return <InstagramIcon className={className} />;
    case 'tiktok':
      return <TiktokIcon className={className} />;
    case 'youtube':
      return <YoutubeIcon className={className} />;
    case 'facebook':
      return <FacebookIcon className={className} />;
    default:
      return null;
  }
};

export const formatPostType = (postType?: PostType): string => {
  if (!postType) return '';

  return postType
    .split('_')
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ');
};

export const PostTypeLabel = ({
  postType,
  className = 'text-[16px] font-medium',
}: {
  postType?: PostType;
  className?: string;
}) => {
  const formattedPostType = formatPostType(postType);
  return formattedPostType ? <span className={className}>{formattedPostType}</span> : null;
};
